/* eslint-disable react-hooks/exhaustive-deps */
/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-07-19 11:39:10
 *
 *******************************************************/
// @flow
import React, { useEffect } from 'react';
import { withI18n } from '@shopify/react-i18n';
import { connect } from 'react-redux';
import { Page, Layout } from '@shopify/polaris';

import {
  exitSABFullscreen,
  enterSABFullscreen
} from 'src/integrations/shopify-app-bridge/fullscreen';
import { handleOpenFullscreen } from 'actions/app-integration-actions';

import AISearch from './ai-search';
import Reviews from './reviews';
import AIRecommendation from './ai-recommendation';
import AIAnalytics from './ai-analytics';
import BoostBanner from './boost-banner';

import history from 'src/routes/history';
import { routes } from 'src/routes';

import AIMain from 'src/assets/images/landing-page/ai-powered/main.png';

import * as subscriptionV3Actions from 'src/stores/actions/subscription-v3-actions';

const AIPowered = props => {
  const { i18n, handleOpenFullscreen, getDetailInvoice } = props;

  // Use effect - Before render page
  useEffect(() => {
    const unsubscribeExit = enterSABFullscreen(handleExit);
    handleOpenFullscreen(true);

    // Get current status addon sync and invoice
    getDetailInvoice();

    return () => {
      unsubscribeExit();
    };
  }, []);

  // handle exit page
  const handleExit = () => {
    history.push(routes.dashboard.view());
    exitSABFullscreen();
    handleOpenFullscreen(false);
  };

  return (
    <div className="BC-Page__AI-Landing-Page">
      <Page
        title={i18n.translate('AdminHTML.LandingPage.AIPowered.title')}
        subtitle={i18n.translate('AdminHTML.LandingPage.AIPowered.subTitle')}>
        <Layout>
          <Layout.Section>
            <img
              className="full-width"
              src={AIMain}
              alt={i18n.translate('AdminHTML.LandingPage.AIPowered.title')}
            />
          </Layout.Section>

          {/* AI Powered Search */}
          <AISearch />

          {/* Review */}
          <Reviews />

          {/* Recommendation */}
          <AIRecommendation />

          {/* Analytics */}
          <AIAnalytics />

          {/* Transform your E-commerce experience with AI */}
          <BoostBanner />
        </Layout>
      </Page>
    </div>
  );
};
const mapDispatchToProps = (dispatch, ownProps) => ({
  getDetailInvoice: () => dispatch(subscriptionV3Actions.getDetailInvoice(ownProps.i18n)),
  handleOpenFullscreen: (isOpenFullScreen: boolean) =>
    dispatch(handleOpenFullscreen(isOpenFullScreen))
});

const mapStateToProps = (state, props) => {
  return {};
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(AIPowered));
